module.exports = __webpack_public_path__ + "img/ice-cream-girl.13ffa43.svg";